 //export const BASE_URL = "http://localhost:5000/api/v1/";

  module.exports = {
      BASE_URL: "https://demo.starsecure.io/api/v1/"
 };
